import { render, staticRenderFns } from "./rryb-advert.vue?vue&type=template&id=e88ef8a6&scoped=true&lang=pug"
import script from "./rryb-advert.vue?vue&type=script&lang=ts"
export * from "./rryb-advert.vue?vue&type=script&lang=ts"
import style0 from "./rryb-advert.vue?vue&type=style&index=0&id=e88ef8a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88ef8a6",
  null
  
)

export default component.exports